import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { MatSelectChange } from '@angular/material/select'
import { FormFieldComponent } from '../form-field/form-field.component'
import { SelectFieldProvider } from './select-field-provider'

@Component({
  selector: 'bdg-select-field',
  templateUrl: './select-field.component.html',
})
export class SelectFieldComponent<T extends { id: number | string }>
  extends FormFieldComponent
  implements ErrorStateMatcher {
  @Input()
  provider: SelectFieldProvider<T>
  @Output()
  selectionChanged: EventEmitter<T> = new EventEmitter()

  // representa o id do field
  @Input()
  id: string

  // representa o id para as opções no select field
  @Input()
  idOption: string

  constructor() {
    super()
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  @Input() set disable(value: boolean) {
    if (value) {
      this.control.disable()
    } else {
      this.control.enable()
    }
  }

  onSelectValueChanged(event: MatSelectChange) {
    this.selectionChanged.emit(event.value)
  }
}
